/** Capacitor Android / iOS OAuth return into the app. */
export const NATIVE_AUTH_REDIRECT_URI = "ai.ironfleet.marketing://auth";

export const NATIVE_SPA_CALLBACK_PATH = "/auth-callback";

export function nativeSpaRedirectUri(apiBase?: string): string | undefined {
  const base = (apiBase ?? "").trim().replace(/\/+$/, "");
  if (!base.startsWith("https://")) {
    return undefined;
  }
  return `${base}${NATIVE_SPA_CALLBACK_PATH}`;
}

export function isNativeAuthRedirect(url: string): boolean {
  if (url.startsWith(`${NATIVE_AUTH_REDIRECT_URI}`) || url.startsWith("ai.ironfleet.marketing://")) {
    return true;
  }
  try {
    const parsed = new URL(url);
    return parsed.pathname === NATIVE_SPA_CALLBACK_PATH || parsed.pathname === `${NATIVE_SPA_CALLBACK_PATH}/`;
  } catch {
    return false;
  }
}

/** Packaged WebView (Android Studio / Play), not Vite on a port. */
export function originLooksLikeNativeWebView(origin: string): boolean {
  try {
    const url = new URL(origin);
    if (url.protocol === "capacitor:") {
      return true;
    }
    if (url.hostname !== "localhost" && url.hostname !== "127.0.0.1") {
      return false;
    }
    return url.port === "" || url.port === "80" || url.port === "443";
  } catch {
    return false;
  }
}

/**
 * MSAL's handleRedirectPromise expects a #fragment. Android intents only deliver
 * query strings, so lift ?code=… into a hash.
 */
export function msalResponseHash(rawUrl: string): string | undefined {
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    return undefined;
  }
  if (url.hash.length > 1) {
    return url.hash.startsWith("#") ? url.hash : `#${url.hash}`;
  }
  const query = url.search.startsWith("?") ? url.search.slice(1) : url.search;
  if (query) {
    return `#${query}`;
  }
  return undefined;
}

export function oauthRedirectError(rawUrl: string): string | undefined {
  const hash = msalResponseHash(rawUrl);
  if (!hash) {
    return undefined;
  }
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  const error = params.get("error");
  if (!error) {
    return undefined;
  }
  const description = (params.get("error_description") ?? "").replace(/\+/g, " ").trim();
  return description || error;
}

export function oauthRedirectHasAuthCode(rawUrl: string): boolean {
  const hash = msalResponseHash(rawUrl);
  if (!hash) {
    return false;
  }
  return new URLSearchParams(hash.replace(/^#/, "")).has("code");
}
